// @ts-nocheck
import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui";
import { ActivityIcon } from "./ActivityIcon";
import { fmtDate } from "./sellerDetail.utils";

export const ActivityTab = ({ d }) => (
  <Card>
    <CardHeader>
      <CardTitle className="text-base">Activity Log</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="relative pl-6">
        {/* Timeline line */}
        <div className="absolute left-[15px] top-0 bottom-0 w-px bg-slate-200 dark:bg-slate-700" />
        <div className="space-y-6">
          {d.activityLog.map((a) => (
            <div
              key={a.id}
              data-testid={`activity-${a.id}`}
              className="relative flex items-start gap-4"
            >
              <div className="absolute -left-6 top-0">
                <ActivityIcon icon={a.icon} />
              </div>
              <div className="ml-6 flex-1">
                <p className="text-sm font-medium text-slate-900 dark:text-slate-100">
                  {a.action}
                </p>
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  {a.detail}
                </p>
              </div>
              <span className="text-xs text-slate-400 dark:text-slate-500 shrink-0">
                {fmtDate(a.timestamp)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </CardContent>
  </Card>
);
